import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from './services/auth/auth.service';
import { AuthGuard } from './services/guard/auth-guard';

@NgModule({
  imports: [CommonModule],
  providers: [AuthGuard, AuthService]
})
export class AuthModule {}



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts